import type { UseFormReturn } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '~/shared/shadcn/ui/form';
import { Input } from '~/shared/shadcn/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/shared/shadcn/ui/select';
import { useGetCurrency } from '~/shared/api/currency-api';
import { getCountryCodeFromCurrency } from '~/shared/utils/currency-country';
import { phoneInputValueToE164 } from '~/shared/utils/phone-input-e164';
import type { ParentFormValues } from '~shared/types/schema';

export function ParentDetails({
  form,
}: {
  form: UseFormReturn<ParentFormValues>;
}) {
  const { register, control } = form;
  const { data: currencyData } = useGetCurrency();
  const defaultCountry = getCountryCodeFromCurrency(currencyData?.name);

  return (
    <div className='mb-6 grid grid-cols-1 gap-4 md:grid-cols-2'>
      <FormField
        control={control}
        name='firstName'
        render={() => (
          <FormItem>
            <FormLabel>First Name</FormLabel>
            <FormControl>
              <Input placeholder='First Name' {...register('firstName')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name='lastName'
        render={() => (
          <FormItem>
            <FormLabel>Last Name</FormLabel>
            <FormControl>
              <Input placeholder='Last Name' {...register('lastName')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name='email'
        render={() => (
          <FormItem>
            <FormLabel>Email</FormLabel>
            <FormControl>
              <Input type='email' placeholder='Email' {...register('email')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name='primaryPhone'
        render={({ field: { value, onChange } }) => (
          <FormItem>
            <FormLabel>Primary Phone</FormLabel>
            <FormControl>
              <PhoneInput
                country={defaultCountry}
                disableCountryGuess={true}
                value={value}
                onChange={(value) => {
                  onChange(phoneInputValueToE164(value));
                }}
                inputStyle={{ width: '100%' }}
                enableSearch={true}
                searchPlaceholder='Search country...'
                searchNotFound='No country found'
                enableAreaCodes={true}
                countryCodeEditable={true}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name='relation'
        render={({ field }) => (
          <FormItem>
            <FormLabel>Relation</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder='Select relation' />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value='Mother'>Mother</SelectItem>
                <SelectItem value='Father'>Father</SelectItem>
                <SelectItem value='Guardian'>Guardian</SelectItem>
                <SelectItem value='Other'>Other</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
